export default "__VITE_ASSET__CBZeVE$$__"